import request from '@/utils/request'

/**
 * 生成用于登录的二维码
 * @param {*} data
 * @returns
 */
export const LoginQrCodeApi = data => {
  return request({
    url: '/loginQrCode',
    method: 'POST',
    data
  })
}

/**
 * 生成用于绑定的二维码
 * @param {*} data
 * @returns
 */
export const WeChatScanBindQRCodeApi = data => {
  return request({
    url: '/loginBindQrCode',
    method: 'POST',
    data
  })
}

/**
 * 扫码登录
 * @param {*} data
 * @returns
 */
export const WeChatScanLoginApi = data => {
  return request({
    url: '/loginWxLogin',
    method: 'POST',
    data
  })
}

/**
 * 绑定微信
 * @param {*} data
 * @returns
 */
export const WeChatBindApi = data => {
  return request({
    url: '/loginBindWx',
    method: 'POST',
    data
  })
}
